import { render, staticRenderFns } from "./contact-block.vue?vue&type=template&id=2f99b812"
import script from "./contact-block.vue?vue&type=script&lang=js"
export * from "./contact-block.vue?vue&type=script&lang=js"
import style0 from "./contact-block.vue?vue&type=style&index=0&id=2f99b812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports